import document from './document';

const additionalCost = `
    amount
    covered
    document {
        ${document}
    }
    id
    notice
    type
`;

export default additionalCost;
